import { http } from "./http";

export const fetchUserSettings = () => (
  http.get("/user")
    .then((response) => response.data)
);

export const putUserDetails = (userDetails) => (
  http.put("/user", userDetails)
);

export const postNewPassword = (passwordDetails) => (
  http.post("/user/password", passwordDetails)
);



// WEBPACK FOOTER //
// ./src/js/api/user-settings.js